import React from "react";
import { Screens } from "../screens";

interface NavTabProps {
  selected: boolean;
  title: string;
  onClick: () => void;
}

/** a tab in the navbar */
const NavTab: React.FC<NavTabProps> = ({ selected, title, onClick }) => {
  return (
    <div
      className={`navTab transition ${selected ? "selectedNavTab" : ""}`}
      onClick={onClick}
      style={{ float: "left", paddingLeft: "20px", paddingRight: "20px" }}
    >
      <p style={{ fontWeight: selected ? "bold" : 500 }}>{title}</p>
    </div>
  );
};

interface NavbarProps {
  selectedTab: number;
  selectTab: (index: number) => void;
}

/** tab navigation bar at the bottom of the screen */
export const Navbar: React.FC<NavbarProps> = ({ selectedTab, selectTab }) => {
  return (
    <div className="navBar">
      {Screens.map((screen, index) => {
        return (
          <NavTab
            key={index}
            selected={index === selectedTab}
            title={screen.title}
            onClick={() => selectTab(index)}
          />
        );
      })}
    </div>
  );
};
